import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import CrearNuevoNegocio from "../../pages/CrearNuevoNegocio/CrearNuevoNegocio";
import ListPlans from "../../pages/ListPlans/ListPlans";
import Layout from "../../components/organisms/Layout/Layout";
import BusinessListing from "../../pages/BusinessListing/BusinessListing";
import BusinessPayments from "../../pages/BusinessPayments/BusinessPayments";
import BusinessReport from "../../pages/BusinessReport/BusinessReport";
import BusinessDefeated from "../../pages/BusinessDefeated/BusinessDefeated";
import AvisosAutomaticos from "../../pages/AvisosAutomaticos/AvisosAutomaticos";
import Manuals from "../../pages/Manuals/Manuals";
import PageNotFound from "../../pages/PageNotFound/PageNotFound";
import EditBusiness from "../../pages/BusinessListing/EditBusiness/EditBusiness";
import TypeBusiness from "../../pages/TypeBusiness/TypeBusiness";
import SupplierGroups from "../../pages/Suppliers/SupplierGroups";
import SupplierDetails from "../../pages/Suppliers/SupplierDetails";
import { LoadingScreen } from "../../components/atoms/LoadingScreen/LoadingScreen";

// import Inicio from "../../pages/Inicio/Inicio";
const Inicio = lazy(() => import("../../pages/Inicio/Inicio"));

export const RoutesAuth = () => {
    return (
        <>
            <Route element={<Layout />}>
                <Route
                    path="/inicio"
                    element={
                        <Suspense
                            fallback={<LoadingScreen title="Cargando inicio" />}
                        >
                            <Inicio />
                        </Suspense>
                    }
                />
                <Route
                    path="/crear-nuevo-negocio"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <CrearNuevoNegocio></CrearNuevoNegocio>
                        </Suspense>
                    }
                />
                <Route
                    path="/editar-negocio/editar/:id"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <EditBusiness />
                        </Suspense>
                    }
                />

                <Route
                    path="/list-plans"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <ListPlans />
                        </Suspense>
                    }
                />
                <Route
                    path="/business-list"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <BusinessListing />
                        </Suspense>
                    }
                />
                <Route
                    path="/type-business"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <TypeBusiness />
                        </Suspense>
                    }
                />
                <Route
                    path="/business-payments"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <BusinessPayments />
                        </Suspense>
                    }
                />
                <Route
                    path="/business-report"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <BusinessReport />
                        </Suspense>
                    }
                />
                <Route
                    path="/reporte-de-negocios-vencidos"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <BusinessDefeated />
                        </Suspense>
                    }
                />
                <Route
                    path="/avisos-aoutomaticos"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <AvisosAutomaticos />
                        </Suspense>
                    }
                />
                <Route
                    path="/ayuda"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <Manuals />
                        </Suspense>
                    }
                />
                <Route
                    path="/proveedores"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <SupplierGroups />
                        </Suspense>
                    }
                />
                <Route
                    path="/proveedores/:name/:id"
                    element={
                        <Suspense fallback={<LoadingScreen />}>
                            <SupplierDetails />
                        </Suspense>
                    }
                />

                <Route path="*" element={<PageNotFound />} />
            </Route>
        </>
    );
};
// export default RoutesAuth;
